import Vue from 'vue'
import Router from 'vue-router'

// Views - Pages
const Page403 = () => import('@/views/pages/Page403')
const Page404 = () => import('@/views/pages/Page404')
const Page500 = () => import('@/views/pages/Page500')


const Layout = () => import('@/views/Layout')
import Home from '@/views/Home'

const Product = () => import('@/views/Product')
const ProductDetail = () => import('@/views/ProductDetail')
const Blog = () => import('@/views/Blog')

Vue.use(Router)

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((error) => {window.location.reload()});
};

let router = new Router({
  base: process.env.NODE_ENV === 'development' ? '/' : '/',
  mode: 'history',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({y: 0}),
  routes: [
    {
      path: '',
      name: 'Trang chủ',
      component: Layout,
      children: [
        {
          path: '/',
          name: 'Home',
          component: Home
        },
        {
          path: '/home',
          name: 'Home2',
          component: Home
        },
        {
          path: '/product',
          name: 'Product',
          component: Product
        },
        {
          path: '/product/:cateCode/:code',
          name: 'ProductDetailCateCode',
          component: ProductDetail
        },
        {
          path: '/product/:code',
          name: 'ProductDetail',
          component: ProductDetail
        },
      ]
    },
    {
      path: '/errors',
      name: 'errors',
      component: {
        render(c) {
          return c('router-view')
        }
      },
      children: [
        {
          path: '403',
          name: 'page403',
          component: Page403
        },
        {
          path: '404',
          name: 'page404',
          component: Page404
        },
        {
          path: '500',
          name: 'page500',
          component: Page500
        }
      ]
    },
    {
      path: '*',
      name: '404',
      component: Page404,
      meta: {
        requiresAuth: true
      }
    }
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js